<template>
  <div class="container-fluid mt-2">
    <h2>Service-Anfrage Vorlage</h2>
    <div class="btn-toolbar" role="toolbar">
      <button @click="saveTemplate" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
    </div>
    <div class="row mt-3">
      <div class="col-sm">
        <div class="form-group">
          <label>Anfrage-Name</label>
          <input class="form-control" type="text" id="mid" v-model="template.map_id"/>
        </div>
        <div class="form-group">
          <label>Skript Logik</label>
          <select v-model="template.scriptName" class="form-control">
            <option value="">Kein Skript</option>
            <option v-for="s in scriptList" :key="s.id">{{  s.id }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Freigabe</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="template.bshop"/>
          <label>bShop</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="template.ihand"/>
          <label>iHand</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="template.ifair"/>
          <label>iFair</label>
        </div>
        <label>Rollen</label><br/>
        <select id="roles" size=3 multiple class="form-control" v-model="template.roles">
          <option value="customer">Kunde</option>
          <option value="ihand">Vertreter</option>
          <option value="apikey">Drittbesteller</option>
          <option value="intern">Innendienst</option>
        </select>
      </div>
      <div class="col-md">
        <h5>Vorlage</h5>
        <div class="wrapper" id="editor">
          <ServiceFieldsEditor :data="template.template"/>
        </div>
      </div>
    </div>
    <b-modal id="htmlSnippets" size="lg" title="HTML Snippets" ok-only>
      <div class="row">
        <h5>HTML</h5>
        <textarea rows="15" v-model="htmlSnippet" class="form-control">
        </textarea>
      </div>
      <div class="row">
        <h5>JavaScript</h5>
        <textarea rows="15" v-model="jsSnippet" class="form-control">
        </textarea>
      </div>
    </b-modal>
    <script type="text/template" id="baseHTML">
      <div class="row">$n
      $t  <div class="form-inline">$n
      $t$t    <label>$NAME:</label>$n
      $t$t    <input type="text" class="form-control" id="$ID"/>$n
      $t  </div>$n
      </div>$n
    </script>
    <script type="text/template" id="mobileBaseJS">
    var fields = [];$n
    function sendRequest(reqid,myform) {$n
    $t  var fd   = new FormData();$n
    $t  for (var idx in fields) {$n
    $t$t    var fentry = fields[idx];$n
    $t$t    if (fentry.form == 'file') {$n
    $t$t$t      fd.append(fentry.name,document.getElementById(fentry.name + '_field').files[0]);$n
    $t$t    } else {$n
    $t$t$t      fd.append(fentry.name,document.getElementById(fentry.name + '_field').value);$n
    $t$t    }$n
    $t  }$n
    $t  fetch('http://ihand-service.de/requests/' + encodeURIComponent(reqid),{$n
    $t$t    method: 'POST',$n
    $t$t    body: fd;$n
    $t  }).then(function(resp) {$n
    $t$t    if (resp.status == 200) {$n
    $t$t$t      alert('Anfrage wurde übermittelt.');$n
    $t$t    } else {$n
    $t$t$t      alert('Anfrage konnte nicht übermittelt werden.');$n
    $t$t    }$n
    $t  })$n
    }$n
    </script>
  </div>
</template>

<script>
import services from '@/modules/services.js'
import scripttasks from '../../modules/scripttasks';
import ServiceFieldsEditor from '@/components/services/ServiceFieldsEditor.vue'

export default {
  name: 'ServiceTemplateEditor',
  components: {
    ServiceFieldsEditor,
  },
  data() {
    return {
      template: { roles: [] , template: {} },
      htmlSnippet: '',
      jsSnippet: '',
      scriptList: []
    }
  },
  created: function() {
    var tid  = this.$route.params.tid;
    var self = this;
    if (tid && tid !== 'new') {
      services.loadtemplate(this,tid,function(data) {
        console.log(data);
        self.template = data;
      })
    }
    // load script task list
    scripttasks.list(this,-1,(data) => {
      console.log(data);
      self.scriptList = data;
    })
  },
  methods: {
    createFieldsHTML: function(fields,ghtml,prefix,fhtml,data) {
      console.log('create html');
      console.log(data);
      for (var key in data) {
        var fentry = data[key];
        console.log('check f: ' + prefix + '.' + key);
        if (fentry) {
          if (fentry["_ctrl"]) {
            var temp = fhtml.replace(/\$n/g,'\n').replace(/\$t/g,'\t').replace("$NAME",key).replace("$ID",key + "_field");
            ghtml += temp;
            fields.push({name:key,type:'text'});
          } else {
            console.log('add group recursive support');
          }
        }
      }
      return ghtml;
    },
    snippetsShop: function() {
      var fields = [];
      var fhtml  = document.getElementById('baseHTML').innerText.replace(/\$n/g,'\n').replace(/\$t/g,'\t');
      this.htmlSnippet = this.createFieldsHTML(fields,'','',fhtml,this.template.template);
      this.jsSnippet = '';
      this.$bvModal.show('htmlSnippets');
    },
    snippetsMobile: function() {
      console.log('snippets mobile');
      var fields = [];
      var fhtml  = document.getElementById('baseHTML').innerText.replace(/\$n/g,'\n').replace(/\$t/g,'\t');
      this.htmlSnippet = this.createFieldsHTML(fields,'','',fhtml,this.template.template);
      this.jsSnippet   = document.getElementById('mobileBaseJS').innerText.replace(/\$n/g,'\n').replace(/\$t/g,'\t').replace("$FIELDS",JSON.stringify(fields));
      this.$bvModal.show('htmlSnippets');
    },
    saveTemplate: function() {
      var self = this;
      services.savetemplate(this,this.template,function(data) {
        self.template = data;
        self.$bvToast.toast('Vorlage gespeichert.',{title:'Service Vorlage',variant:'success'})
      })
    }
  }
}
</script>
